module.exports = __webpack_public_path__ + "static/media/search.cadcc810.svg";